import { createSelector } from 'reselect'

import requestStatuses, { getRequestStatus } from '@cinch/oxd-utils/request-status/src'

const getSummaryStatus = (state: any) => state.entities.vehicleSummaryCache.status

export default createSelector(getSummaryStatus, (statuses) => (id: any) =>
  getRequestStatus(statuses[id] || requestStatuses.INITIAL),
)
